// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1XbMV","title":"BackImages_title__2-JKS","images":"BackImages_images__3RK_4"};